import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import labels from "emun.order/_labels";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
const $rootScope = resolve("$rootScope");
import config from "emun.cart/cart.config";

export default class AddCommitmentPromptController {
	constructor(notify) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.title = "Add " + $ctrl.product.id + " to Commitments...";

		$ctrl.labels = labels;
		$ctrl.notify = notify;
		$ctrl.bus = new ServiceBus();
		$ctrl.config = config;
		if ($ctrl.product.isCommited) {
			$ctrl.commitment = $ctrl.product.commitments[0];
			$ctrl.qty = $ctrl.commitment.quantity || $ctrl.commitment.Quantity;
		} else $ctrl.qty = $ctrl.product.minimumOrderQty;
	}

	$onInit() {
		const $ctrl = this;
	}

	removeCommitment() {
		const $ctrl = this;
		return $ctrl.bus.send("RemoveCommitment", $ctrl.commitment).then(function(response) {
			$ctrl.product.isCommited = false;
			$ctrl.$dismiss();
			return response.data;
		})
	}

	decrementQty() {
		const $ctrl = this;
		$ctrl.qty -= $ctrl.product.purchaseIncrement || 1;
	}
	incrementQty() {
		const $ctrl = this;
		$ctrl.qty += $ctrl.product.purchaseIncrement || 1;
	}

	addInterest() {
		const $ctrl = this;
		if ($ctrl.product.isInterested) {
			return $ctrl.$cart.bus.send("RemoveInterest", $ctrl.product.interests[0]).then(function(response) {
				$ctrl.$notify.success(
				  "Item " +
					$ctrl.product.id +
					" removed from interests.",
				  {
					title: "Interests",
					ttl: 2000,
					disableCountDown: true,
				  }
				);
				$ctrl.product.isInterested = false;
				$ctrl.product.interests = [];
				$ctrl.$dismiss();
				return response.data;
			  });
		} else {
			return $ctrl.$cart.bus.send("AddInterest", {
				RetailerId: $ctrl.$session.meta.CurrentRetailerId,
				ProductId: $ctrl.product.id,
				Quantity: 1
			}).then(function(response) {
				$ctrl.$notify.success(
				  "Item " +
					$ctrl.product.id +
					" added to interests",
				  {
					title: "Interests",
					ttl: 2000,
					disableCountDown: true,
				  }
				);
				$ctrl.product.isInterested = true;
				$ctrl.product.interests = [];
				$ctrl.product.interests.push(response.data);
				$ctrl.$dismiss();
				return response.data;
			});
		}
	}

	submit() {
		const $ctrl = this;
		return $ctrl.bus.send("AddCommitment", {
			RetailerId: $ctrl.$session.meta.CurrentRetailerId,
			ProductId: $ctrl.product.id,
			Quantity: $ctrl.qty || 1,
			type: "Commitment"
			}).then(function(response) {
				$ctrl.product.isCommited = true;
				$ctrl.product.commitments = [];
				$ctrl.product.commitments.push(response.data);
			$ctrl.$notify.success(
				"Item " +
				$ctrl.product.id +
				" added to commitments.  Qty " +
				$ctrl.qty,
				{
				title: "Commitments",
				ttl: 2000,
				disableCountDown: true,
				}
			);
			$ctrl.$dismiss();
			return response.data;
		});
	}

}
